/*
  DoggyLove – Herzen-Rechner (Theme-Block)
  ----------------------------------------
  Kein jQuery, keine Abhängigkeiten. Initialisiert jeden [data-dlhr-root].
  Konfiguration + Preise kommen aus data-Attributen (serverseitig gerendert).
  Nichts wird serverseitig gespeichert. Optionaler dataLayer.push beim Ergebnis.
*/
(function () {
  'use strict';

  function euNum(str) {
    if (str == null) return NaN;
    return parseFloat(String(str).replace(',', '.'));
  }

  function initRoot(root) {
    if (root.dataset.dlhrReady === '1') return;
    root.dataset.dlhrReady = '1';

    var cfg = {
      heartsPerTin: parseInt(root.dataset.heartsPerTin, 10) || 60,
      startWeeks: parseInt(root.dataset.startWeeks, 10) || 8,
      discountCode: root.dataset.discountCode || '',
      discountPct: parseInt(root.dataset.discountPct, 10) || 0,
      subscriptionPct: parseInt(root.dataset.subscriptionPct, 10) || 0
    };
    var d = root.dataset;
    var bands = [
      { max: euNum(d.b1Max), hearts: parseInt(d.b1H, 10) || 1, label: d.b1Label || '', hint: d.b1Hint || '' },
      { max: euNum(d.b2Max), hearts: parseInt(d.b2H, 10) || 2, label: d.b2Label || '', hint: d.b2Hint || '' },
      { max: euNum(d.b3Max), hearts: parseInt(d.b3H, 10) || 3, label: d.b3Label || '', hint: d.b3Hint || '' },
      { max: euNum(d.b4Max), hearts: parseInt(d.b4H, 10) || 4, label: d.b4Label || '', hint: d.b4Hint || '' },
      { max: Infinity,       hearts: parseInt(d.b5H, 10) || 5, label: d.b5Label || '', hint: d.b5Hint || '' }
    ];

    var q = function (sel) { return root.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var trigger = q('[data-dlhr-trigger]');
    var modal = q('[data-dlhr-modal]');
    var dialog = q('[data-dlhr-dialog]');
    if (!trigger || !modal) return;

    var step1 = q('[data-dlhr-step="1"]');
    var step2 = q('[data-dlhr-step="2"]');
    var nameInput = q('[data-dlhr-name]');
    var weightInput = q('[data-dlhr-weight]');
    var weightError = q('[data-dlhr-weight-error]');
    var calcBtn = q('[data-dlhr-calc]');
    var backBtn = q('[data-dlhr-back]');
    var addBtn = q('[data-dlhr-add]');
    var errorBox = q('[data-dlhr-error]');

    var state = { name: '', weight: NaN, age: '', feed: '', vid: '' };

    /* ---------- Chips (Single-Select je Gruppe) ---------- */
    function wireChips(group, onPick) {
      var chips = qa('[data-dlhr-' + group + ']');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chips.forEach(function (c) { c.classList.remove('is-active'); c.setAttribute('aria-pressed', 'false'); });
          chip.classList.add('is-active');
          chip.setAttribute('aria-pressed', 'true');
          onPick(chip);
        });
      });
    }
    wireChips('age', function (c) { state.age = c.getAttribute('data-value') || ''; });
    wireChips('feed', function (c) { state.feed = c.getAttribute('data-value') || ''; });
    wireChips('sorte', function (c) { state.vid = c.getAttribute('data-vid') || ''; });

    function selectSorteById(id) {
      var chips = qa('[data-dlhr-sorte]');
      var target = null;
      chips.forEach(function (c) { if (c.getAttribute('data-vid') === String(id)) target = c; });
      if (!target) { target = chips[0]; }
      if (target) {
        chips.forEach(function (c) { c.classList.remove('is-active'); c.setAttribute('aria-pressed', 'false'); });
        target.classList.add('is-active'); target.setAttribute('aria-pressed', 'true');
        state.vid = target.getAttribute('data-vid') || '';
      }
    }

    function currentProductVariantId() {
      var pf = document.querySelector('product-form-component') || document;
      var input = pf.querySelector ? pf.querySelector('[name="id"]') : null;
      return input ? input.value : '';
    }

    /* ---------- Modal (a11y) ---------- */
    var lastFocused = null;
    function focusable() {
      return qa('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
        .filter(function (el) { return el.offsetParent !== null; });
    }
    function onKeydown(e) {
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key === 'Tab') {
        var f = focusable();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    function openModal() {
      lastFocused = document.activeElement;
      selectSorteById(currentProductVariantId());
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      showStep(1);
      document.addEventListener('keydown', onKeydown);
      setTimeout(function () { if (weightInput) weightInput.focus(); }, 60);
    }
    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }
    trigger.addEventListener('click', openModal);
    qa('[data-dlhr-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });

    function showStep(n) {
      if (step1) step1.hidden = (n !== 1);
      if (step2) step2.hidden = (n !== 2);
      if (dialog) dialog.scrollTop = 0;
    }

    /* ---------- Berechnung ---------- */
    function bandForWeight(w) {
      for (var i = 0; i < bands.length; i++) {
        if (w <= bands[i].max) return bands[i];
      }
      return bands[bands.length - 1];
    }
    function tmpl(str, map) {
      return str.replace(/\{(\w+)\}/g, function (_, k) { return (map[k] != null ? map[k] : ''); });
    }

    function calculate() {
      state.name = (nameInput && nameInput.value ? nameInput.value : '').trim().slice(0, 24);
      state.weight = euNum(weightInput && weightInput.value);
      if (isNaN(state.weight) || state.weight < 1 || state.weight > 90) {
        if (weightError) weightError.hidden = false;
        if (weightInput) { weightInput.setAttribute('aria-invalid', 'true'); weightInput.focus(); }
        return;
      }
      if (weightError) weightError.hidden = true;
      if (weightInput) weightInput.removeAttribute('aria-invalid');
      if (!state.vid) selectSorteById(currentProductVariantId());

      var band = bandForWeight(state.weight);
      var hpd = band.hearts;
      var weeks = cfg.startWeeks;
      var totalHearts = hpd * 7 * weeks;
      var tins = Math.max(1, Math.ceil(totalHearts / cfg.heartsPerTin));
      var qty = tins >= 2 ? 2 : 1;
      state.band = band; state.hpd = hpd; state.weeks = weeks; state.tins = tins; state.qty = qty;

      renderResult();
      showStep(2);

      // Datenschutz-konformes Event (ohne Name, ohne Gewicht)
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'herzen_rechner_result', hearts_per_day: hpd, tins: tins, qty: qty });
      } catch (e) {}
    }

    function renderResult() {
      var nameOr = state.name || 'dein Hund';
      var nameCap = state.name || 'Dein Hund';
      var setText = function (sel, val) { var el = q(sel); if (el) el.textContent = val; };

      setText('[data-dlhr-hpd]', state.band.label || String(state.hpd));
      setText('[data-dlhr-weeks]', String(state.weeks));
      setText('[data-dlhr-tins]', state.tins + ' ' + (state.tins === 1 ? 'Dose' : 'Dosen'));

      // Hinweis der Gewichtsstufe
      var hintEl = q('[data-dlhr-hint]');
      if (hintEl) {
        if (state.band.hint) { hintEl.textContent = state.band.hint; hintEl.hidden = false; }
        else { hintEl.hidden = true; }
      }

      // Empfehlungstext (konform, keine Wirkaussagen)
      var reco = tmpl('Für {name} bei {w} kg empfehlen wir {label}. Für einen ruhigen Start über {weeks} Wochen brauchst du dafür {tins} {doseWord}.', {
        name: nameOr, w: String(state.weight).replace('.', ','), label: state.band.label || (state.hpd + ' pro Tag'),
        weeks: state.weeks, tins: state.tins, doseWord: state.tins === 1 ? 'Dose' : 'Dosen'
      });
      var ageAdd = {
        'unter1': ' Bei jungen Hunden im Wachstum die Menge langsam steigern und im Zweifel mit deiner Tierärztin oder deinem Tierarzt abstimmen.',
        '1bis7': ' Am besten fest in die tägliche Routine einbauen.',
        'ueber7': ' Bei älteren Hunden gern auf mehrere kleine Gaben über den Tag verteilen.'
      }[state.age] || '';
      var feedAdd = {
        'nichts': ' Führe die Snacks über ein paar Tage langsam ein.',
        'pulver': ' Du kannst schrittweise von Pulver oder angerührter Ulmenrinde auf die Snacks umstellen.',
        'tabletten': ' Die Snacks lassen sich einfach zusätzlich zur gewohnten Routine geben.'
      }[state.feed] || '';
      var recoEl = q('[data-dlhr-reco]');
      if (recoEl) recoEl.textContent = reco + ageAdd + feedAdd;

      // Aktueller Sorte-Chip -> Preise
      var chip = q('[data-dlhr-sorte].is-active') || q('[data-dlhr-sorte]');
      var price1 = chip ? chip.getAttribute('data-price') : '';
      var price2 = chip ? chip.getAttribute('data-price2') : '';
      var price2total = chip ? chip.getAttribute('data-price2total') : '';
      var strike = chip ? chip.getAttribute('data-pricestrike') : '';
      var sorteLabel = chip ? (chip.getAttribute('data-label') || '') : '';

      var offer = q('[data-dlhr-offer]');
      if (offer) {
        var html = '';
        if (state.tins <= 1) {
          html =
            '<p class="dlhr__offer-line"><strong>1 Dose ' + sorteLabel + '</strong> – ' + price1 + '</p>' +
            '<p class="dlhr__offer-sub">Danach bequem im Spar-Abo (−' + cfg.subscriptionPct + '%), jederzeit kündbar.</p>';
        } else if (state.tins === 2) {
          html =
            '<p class="dlhr__offer-line"><strong>2 Dosen ' + sorteLabel + '</strong></p>' +
            '<p class="dlhr__offer-sub">Zweite Dose −' + cfg.discountPct + '% mit dem Code <code class="dlhr__code">' + cfg.discountCode + '</code>.</p>' +
            '<p class="dlhr__offer-price"><s>' + strike + '</s> <b>' + price2 + '</b> für die zweite Dose · gesamt ca. ' + price2total + '</p>';
        } else {
          html =
            '<p class="dlhr__offer-line"><strong>2 Dosen ' + sorteLabel + ' jetzt</strong></p>' +
            '<p class="dlhr__offer-sub">Zweite Dose −' + cfg.discountPct + '% mit Code <code class="dlhr__code">' + cfg.discountCode + '</code>. Weitere Dosen bequem im Spar-Abo (−' + cfg.subscriptionPct + '%).</p>' +
            '<p class="dlhr__offer-price"><s>' + strike + '</s> <b>' + price2 + '</b> für die zweite Dose · gesamt ca. ' + price2total + '</p>';
        }
        offer.innerHTML = html;
      }
    }

    /* ---------- Video: Quelle erst bei Klick ---------- */
    var playBtn = q('[data-dlhr-play]');
    if (playBtn) {
      playBtn.addEventListener('click', function () {
        var vid = q('[data-dlhr-video]');
        var frameWrap = q('[data-dlhr-video-embed]');
        if (vid) {
          var src = vid.getAttribute('data-src');
          if (src && !vid.src) vid.src = src;
          vid.hidden = false; vid.play && vid.play();
        } else if (frameWrap) {
          var iframe = frameWrap.querySelector('iframe[data-src]');
          if (iframe && !iframe.src) iframe.src = iframe.getAttribute('data-src');
          frameWrap.hidden = false;
        }
        var poster = q('[data-dlhr-video-poster]');
        if (poster) poster.hidden = true;
      });
    }

    /* ---------- Warenkorb ---------- */
    function showError(msg) {
      if (!errorBox) { alert(msg); return; }
      errorBox.textContent = msg;
      errorBox.hidden = false;
    }
    function clearError() { if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; } }

    if (addBtn) addBtn.addEventListener('click', function () {
      clearError();
      if (!state.vid) { showError('Bitte eine Sorte wählen.'); return; }
      var qty = state.qty || 1;
      var useCode = qty >= 2 && cfg.discountCode;
      addBtn.classList.add('is-loading'); addBtn.disabled = true;

      var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      var drawer = document.querySelector('cart-drawer-component');
      var sectionWrap = drawer ? drawer.closest('[id^="shopify-section-"]') : null;
      var sectionId = sectionWrap ? sectionWrap.id.replace('shopify-section-', '') : null;

      var body = { items: [{ id: state.vid, quantity: qty }] };
      if (sectionId) body.sections = sectionId;

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) { throw new Error((res.d && res.d.description) || 'Konnte nicht in den Warenkorb legen.'); }
          if (useCode) {
            window.location.href = '/discount/' + encodeURIComponent(cfg.discountCode) + '?redirect=/cart';
            return;
          }
          try {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: null, sourceId: root.id, data: { source: 'dl-herzen-rechner', sections: res.d.sections, itemCount: qty, variantId: String(state.vid) } }
            }));
          } catch (e) {}
          if (drawer && typeof drawer.open === 'function') { closeModal(); drawer.open(); }
          else { window.location.href = '/cart'; }
        })
        .catch(function (err) {
          addBtn.classList.remove('is-loading'); addBtn.disabled = false;
          showError(err && err.message ? err.message : 'Etwas ist schiefgelaufen. Bitte erneut versuchen.');
        });
    });

    if (calcBtn) calcBtn.addEventListener('click', calculate);
    if (weightInput) weightInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); calculate(); } });
    if (backBtn) backBtn.addEventListener('click', function () { clearError(); showStep(1); setTimeout(function () { if (weightInput) weightInput.focus(); }, 40); });
  }

  function initAll(scope) {
    var r = (scope && scope.querySelectorAll) ? scope : document;
    r.querySelectorAll('[data-dlhr-root]').forEach(initRoot);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) { initAll(e.target); });
})();
